import "./bootstrap";
import "../css/app.css";
import "./nova-override.js";

import { createApp, provide, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "ziggy-js";
import { setupI18n } from "@/helpers/nova-utils/utils";
import { DefaultApolloClient } from '@vue/apollo-composable';
import apolloClient from './helpers/apollo-client';

const appName = "STAPP";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),

    setup({ el, App, props, plugin }) {
        const vueApp = createApp({
            setup() {
                localStorage.removeItem('graphql_token');
                localStorage.removeItem('imp_graphql_token');

                provide(DefaultApolloClient, apolloClient);
            }, render: () => h(App, props)
        });

        vueApp.use(plugin)
        vueApp.use(ZiggyVue);

        const i18n = setupI18n(vueApp);

        const locale =
            (props && props.initialPage && props.initialPage.props && props.initialPage.props.locale) ||
            document.documentElement.lang ||
            "nl-nl";

        i18n.global.locale.value = locale;
        document.documentElement.lang = locale;

        const count = Object.keys(i18n.global.getLocaleMessage(locale) || {}).length;
        console.log("[i18n] locale:", locale, "| keys:", count);

        // Optional: keep locale synced on Inertia navigations
        document.addEventListener("inertia:success", (e) => {
            const next = e.detail?.page?.props?.locale;
            if (next && next !== i18n.global.locale.value) {
                i18n.global.locale.value = next;
                document.documentElement.lang = next;
                // console.log("[i18n] switched to:", next);
            }
        });

        vueApp.config.errorHandler = (err, instance, info) => {
            console.error(`[Vue Error] ${err?.message || err}`, { err, component: instance?.type?.name || instance, info });
        };


        return vueApp.mount(el);
    },
    progress: {
        color: "#4B5563",
    },
});
